export default __webpack_public_path__ + "static/media/6.76c3222e.png";